import type { IntlShape } from 'react-intl';
import inflect from 'czech-inflection';

export const firstNameSalutation = (firstName: string, intl: IntlShape): string =>
  intl.locale === 'cs-CZ'
    ? inflect({
        word: firstName,
        grammarCase: 5,
      })
    : firstName;
